// Browser error reporting (owner 2026-11-03: "make sure the UI works"). Uncaught errors, unhandled promise
// rejections and page crashes (AppErrorBoundary) go to POST /api/client-errors, which writes one log line each;
// the Monday health report lists them. At most MAX_REPORTS per page load, each message once. No emails, no
// query strings (the API keeps the page path only), no request data.
import { APP_VERSION } from '../appVersion';

const API_URL = process.env.REACT_APP_API_URL || 'https://chemical-monitor-api-57459833175.us-central1.run.app/api';
const MAX_REPORTS = 10;

let sent = 0;
const seen = new Set();
let context = { orgId: null, role: null };

// Called by the app when the signed-in account changes.
export function setClientErrorContext({ orgId = null, role = null } = {}) {
  context = { orgId, role };
}

export function reportClientError({ kind = 'error', message, source = null, line = null, column = null, stack = null, componentStack = null }) {
  try {
    if (process.env.NODE_ENV !== 'production' || !message) return;
    const key = `${kind}|${message}`;
    if (seen.has(key) || sent >= MAX_REPORTS) return;
    seen.add(key);
    sent += 1;
    fetch(`${API_URL}/client-errors`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({
        kind,
        message: String(message).slice(0, 500),
        page: window.location.pathname,
        source,
        line,
        column,
        stack: stack ? String(stack).slice(0, 2000) : null,
        componentStack: componentStack ? String(componentStack).slice(0, 1000) : null,
        appVersion: APP_VERSION,
        orgId: context.orgId,
        role: context.role,
        // The weekly automated page check runs a controlled browser; its reports are tagged.
        uiCheck: navigator.webdriver === true
      })
    }).catch(() => {});
  } catch (error) {
    // Reporting must never break the page.
  }
}

export function installClientErrorReporter() {
  window.addEventListener('error', (event) => {
    // Failed <img>/<script> loads also fire 'error' but carry no message.
    if (!event.message) return;
    reportClientError({
      kind: 'error',
      message: event.message,
      source: event.filename || null,
      line: Number.isInteger(event.lineno) ? event.lineno : null,
      column: Number.isInteger(event.colno) ? event.colno : null,
      stack: event.error?.stack || null
    });
  });
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    const message = reason?.message || (typeof reason === 'string' ? reason : null);
    if (!message) return;
    reportClientError({ kind: 'unhandledrejection', message, stack: reason?.stack || null });
  });
}
